// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__mXhPo","hasDrawer":"Footer_hasDrawer__u3VUt","image":"Footer_image__iU2_y","content":"Footer_content__h09_M"};